import { ReactNode } from "react";
import { Navigation } from "@/components/Navigation";

interface AppShellProps {
  children: ReactNode;
  /** Render children full-bleed without the constrained content container */
  fullBleed?: boolean;
  className?: string;
}

/**
 * Authenticated app shell: top Navigation + responsive main container.
 * Use for any signed-in page so the header/banner stays consistent across
 * mobile, tablet, and desktop.
 */
export const AppShell = ({ children, fullBleed = false, className = "" }: AppShellProps) => {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <Navigation />
      <main
        className={
          fullBleed
            ? `flex-1 w-full ${className}`
            : `flex-1 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 ${className}`
        }
      >
        {children}
      </main>
    </div>
  );
};

export default AppShell;
